import { createContext, Dispatch } from 'react';
import { initialGlobalState } from './reducer';
import { FormAction, GlobalState } from './types';

// Contains the actual data
export const GlobalContext = createContext<GlobalState>(initialGlobalState);

// Manages the dispatches
export const GlobalDispatchContext = createContext<Dispatch<FormAction> | null>(null);